<template>
    <div class="subscription-blocked">
        <div class="subscription-blocked__card">
            <div class="subscription-blocked__icon">
                <v-icon size="44" color="#ffb74d">mdi-pause-circle-outline</v-icon>
            </div>
            <h1 class="subscription-blocked__title">Работа системы временно приостановлена</h1>
            <p class="subscription-blocked__text">
                Доступ к CRM будет восстановлен автоматически после продления оплаты.
                Все входящие заявки и звонки продолжают сохраняться — ничего не потеряется.
            </p>
            <p class="subscription-blocked__hint">По вопросам продления обратитесь к администратору.</p>
            <v-btn outlined color="#ffb74d" :loading="checking" @click="$emit('recheck')">
                <v-icon left>mdi-refresh</v-icon>
                Проверить снова
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubscriptionBlocked",
    props: {
        checking: {type: Boolean, default: false}
    }
}
</script>

<style lang="scss" scoped>
.subscription-blocked {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: radial-gradient(ellipse at top, #2a2418 0%, #121212 60%);
}

.subscription-blocked__card {
    max-width: 520px;
    width: 100%;
    padding: 40px 32px;
    text-align: center;
    border-radius: 16px;
    background: #1e1e1e;
    border: 1px solid rgba(255, 183, 77, 0.25);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.subscription-blocked__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
    border-radius: 50%;
    background: rgba(255, 183, 77, 0.12);
}

.subscription-blocked__title {
    margin-bottom: 16px;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.3;
    color: #fff;
}

.subscription-blocked__text {
    margin-bottom: 8px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.6;
}

.subscription-blocked__hint {
    margin-bottom: 28px;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.5);
}
</style>
